import Route from '@ember/routing/route'

export default class RexRoute extends Route {
  queryParams = {
    studentGrade: {
      refreshModel: true,
      replace: true,
    },
    contentLevel: {
      refreshModel: true,
      replace: true,
    },
  }
}
